<template>
  <div class="ux-ugc-wrap">
    <div class="data-panel ugc-panel">
      <ue :pd="ues.pd" :content="ues.content" v-if="$service.PROJ_CODE==='l28' || $service.PROJ_CODE==='demo'">
        <template><span class="ugc-panel-remark">默认按UGC玩法最近一次群测得分降序排序。</span></template>
      </ue>
      <div class="data-panel-header" style="height: auto;">
      </div>      
      <div class="data-panel-content">
        <div className='table-container' id="ux-ugcgroup-table">
          <table class="custom-ugc-gameplay-table" id="ux-ugcgroup-table-thead">
            <thead>
              <tr class="custom-ugc-gameplay-table-tr">
                <th :key="column.id" v-for="column in columns" :style="{'width': column.width}" :class="`${column.sorter?'sortable':''} ${column.header_class?column.header_class:''}`">
                  <div @click="onChangeSorter(column.id)">
                    <span>{{column.title}}</span>
                    <span :class="`sorter-icon ${sorter.id===column.id?`sorter-${sorter.order}`:''}`" v-if="column.sorter">
                      <a-icon type="caret-up" />
                      <a-icon type="caret-down" />
                    </span>
                    <a-tooltip v-if="column.tooltip" :title="column.tooltip">
                      <a-icon type="question-circle" class="question" style="font-size:15px;"/></a-tooltip>
                    <a-popover placement="bottom" overlayClassName="ugc-table-filter-container"  v-if="column.filter">
                      <template slot="content">
                        <div class="ugc-table-filter-box">
                          <p><a-input placeholder="搜索" v-model="filterOptionFilters[column.id]"/></p>
                          <p v-for="v in filterOptions[column.id]" :key="v" v-show="!filterOptionFilters[column.id] || v.toLowerCase().indexOf(filterOptionFilters[column.id].toLowerCase())>=0"><a-checkbox :checked="filters[column.id].indexOf(v)>=0" @change="(e)=>filterChange(column.id, v, e)">{{ v }}</a-checkbox></p>
                        </div>
                      </template>
                      <template slot="title">
                        <span><a-checkbox  @change="(e)=>filterChangeAll(column.id, e)" :checked="filters[column.id].length===filterOptions[column.id].length" :indeterminate="filters[column.id].length>0 && filters[column.id].length<filterOptions[column.id].length">全选</a-checkbox></span>
                      </template>
                      <span :class="`filter-icon ${filters[column.id].length!==filterOptions[column.id].length?'active':''}`" @click="(e)=>{e.stopPropagation();}"><a-icon type="filter" theme="filled" /></span>
                    </a-popover>
                  </div>
                </th>
              </tr>
            </thead>
          </table>
          <table class="custom-ugc-gameplay-table" id="ux-ugcgroup-table-tbody">
            <tbody>
              <tr :key="record.gameplay" class="custom-ugc-gameplay-table-tr" v-for="record in filterDatas">
                <td v-for="column in columns" :key="`${record.gameplay}_${column.id}`" :style="{'width': column.width}">
                  <!-- 视频 -->
                  <div v-if="column.render==='video'" :title="record.video?'点击查看录屏':null">
                    <span :class="record.video?'link':null" @click="record.video?modal = {show: true, path: record.video, title: record.gameplay}:null">{{ record[column.id] }}</span>
                  </div>
                  <div v-if="column.render==='trend'" >
                    <div style="margin:0 auto; padding: 5px 10px 0;">
                      <trendChart :id="`${record.gameplay}_trend`" :data="record.tests" v-if="record.tests && record.tests.length>0"/>
                      <div v-else style="line-height:80px">-</div>
                    </div>
                  </div>
                  <div v-if="column.render==='score'">
                    {{ record[column.id]?record[column.id].toFixed(1):record[column.id] }}
                  </div>
                  <div v-if="!column.render">
                    {{ record[column.id] }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <a-modal :title="modal.title" :width="800" :visible="modal.show" :maskClosable="true" @cancel="modal={show:false, path: undefined, title: undefined}">
      <video :src="`${modal.path}?token=viewBCVideoL28.R.eT3DKv3ho6opGQQ5SHDK4VH4`" controls="controls" style="width:100%">
        您的浏览器不支持 video 标签。
      </video>
      <template slot="footer">
        <a-button @click="modal={show:false, path: undefined, title: undefined}" type="default">关闭</a-button>
      </template>
    </a-modal>    
  </div>
</template>

<script>

import Vue from 'vue'
import ue from "./ue.vue";
import trendChart from "./groupTrendChart.vue";
import IssueTable from "./issueTable.vue";
import { Checkbox, Popconfirm, Input } from 'ant-design-vue';
Vue.use(Checkbox)
Vue.use(Popconfirm)
Vue.use(Input)

const columns = [
  {id: 'gameplay', title:'玩法', width: '250px', sorter: true, render: 'video', expandable: true, filter: true},
  {id: 'pd', title:'负责人',  sorter: true, width: '200px', filter: true},
  {id: 'score', title:'手柄版（XGP）内部群测变化趋势', width: '920px', sorter: true, render: 'trend', header_class:'inner', tooltip:'单次分数=该次内部测试的平均得分（去除评分人数不足5人的情况）'},
  {id: 'ugc_score', title:'外部尖叫度对比',  sorter: true, render: 'score',  header_class:'outer', tooltip:'该尖叫度分数=UGC玩法外部实验室测试中尖叫度得分'},
]

const sorterFnc = (p, n)=> {
  return p==n?0:n==null?1:p==null?-1:typeof(p)==='number'?p-n:p.localeCompare(n)
}

export default {
  name: 'uxUGCGameplayGroupTestPanel',
  props: {
    api: {
      type: String,
    },
    title: {
      type: String,
      default: 'UGC玩法XGP群测得分'
    }
  },  
  components: {
    ue, trendChart, IssueTable
  },
  filters:{
		nilFormat: function(value){
      return value!=null?value:'-'
		}
	},
  data() {
    return {
      ues: {
        pd: [{name: '应一新', email: 'yingyixin@corp.netease.com'}],
        content: []
      },
      loading: false,
      sorter: {id: 'score', order: 'desc'},
      datas: [],
      filterOptions: {
        gameplay: [], 
        pd: [],
      },
      filters: {
        gameplay: [],
        pd: [],
      },
      filterOptionFilters: {
        gameplay: undefined,
        pd: undefined,
      },
      sortedDatas: [],
      columns,
      modal: {
        show: false,
        path: undefined,
        title: undefined
      },
    }
  },
  mounted() {
    this.getData();
    if(document.getElementById('ux-ugcgroup-table-tbody')) {
      const width = document.getElementById('ux-ugcgroup-table-tbody').getBoundingClientRect().width
      const top = document.getElementById('ux-ugcgroup-table').getBoundingClientRect().top
      if(top<=0 && width>0) {
        document.getElementById('ux-ugcgroup-table-thead').setAttribute('style', `position: fixed; top:0; width: ${width}px`);
      }
      else {
        document.getElementById('ux-ugcgroup-table-thead').removeAttribute('style');
      }
      
      window.addEventListener('scroll', function() {
        const width = document.getElementById('ux-ugcgroup-table-tbody').getBoundingClientRect().width
        const top = document.getElementById('ux-ugcgroup-table').getBoundingClientRect().top
        if(top<=0 && width>0) {
          document.getElementById('ux-ugcgroup-table-thead').setAttribute('style', `position: fixed; top:0; width: ${width}px`);
        }
        else {
          document.getElementById('ux-ugcgroup-table-thead').removeAttribute('style');
        }
      });
    }
  },
  computed: {
    filterDatas() {
      return this.sortedDatas.filter((row)=>{
        let flag = true
        if(this.filters.gameplay.length > 0) {
          if(this.filters.gameplay.indexOf(row.gameplay) < 0) {
            flag = false
          }
        }
        if(this.filters.pd.length > 0) {
          if(this.filters.pd.indexOf(row.pd) < 0) {
            flag = false
          }
        }
        return flag
      })
    },
  },
  methods: {
    getData() {
      this.loading = true;
      this.$service.query_fixed_module(this.api).then(res => {
        this.loading = false;
        if (res.data) {
          const _datas = res.data?res.data.data:[] || [];
          this.datas = _datas
          const _gameplays_dict = {}
          const _gameplays = []
          const _pds_dict = {}
          const _pds = []

          _datas.forEach(row=>{
            if(!_gameplays_dict[row.gameplay]) {
              _gameplays.push(row.gameplay)
              _gameplays_dict[row.gameplay] = true
            }
            if(!_pds_dict[row.pd]) {
              _pds.push(row.pd)
              _pds_dict[row.pd] = true
            }
            row.score = row.tests && row.tests.length >=1 ? row.tests[row.tests.length-1].score:-999
          })
          this.filterOptions={gameplay: _gameplays, pd: _pds}
          this.filters = { gameplay: [..._gameplays], pd: [..._pds] }
          this.sortData(_datas, {id: 'score', order: 'desc'},)
        }
      }).catch((error) => {
        this.loading = false;
        console.log(error)
      });
    },
    onChangeSorter(id) {
      let sorter = this.sorter
      if(this.sorter.id === id) {
        if(this.sorter.order === 'desc') {
          sorter = {id: undefined, order: undefined}
        }
        else {
          sorter = {id, order: 'desc'}
        }
      } 
      else {
        sorter = {id, order: 'asc'}
      }
      this.sorter = sorter
      this.sortData(this.datas, sorter)
    },
    sortData(datas, sorter) {
      window.console.log(sorter)
      const _datas = datas.sort((p, n)=>{
        const p1 = sorterFnc(p.ugc_score, n.ugc_score)
        if(p1!=0) {
          return -p1
        }
        const p2 = sorterFnc(p.score, n.score)
        return -p2
      })
      let res = _datas
      if(sorter.id) {
        const c = columns.find(c=>c.id===sorter.id)
        if(c && c.sorter) {
          if(c.sorter === true) {
            res = _datas.sort((a, b)=>sorterFnc(a[c.id], b[c.id]))
          }
          else {
            res = _datas.sort((a, b)=>c.sorter(a, b))
          }
          if(sorter.order === 'desc') {
            res = res.reverse()
          }
        }
      }
      
      this.sortedDatas = res
      this.reload = true
      this.$nextTick(()=>{
        this.reload = false
      })
    },
    filterChange(column, value, e) {
      const _filters = {...this.filters}
      const index = this.filters[column].indexOf(value)
      if(e.target.checked && index<0) {
        _filters[column] = [...this.filters[column], value]
        this.filters = _filters
      }
      if(!e.target.checked && index>=0) {
        const _filterItems = [...this.filters[column]]
        _filterItems.splice(index, 1)
        _filters[column] = _filterItems
        this.filters = _filters
      }
    },
    filterChangeAll(column, e) {
      const _filters = {...this.filters}
      if(e.target.checked) {
        _filters[column] = [...this.filterOptions[column]]
      }
      else {
        _filters[column] = []
      }
      this.filters = _filters
    },
  }
}
</script>

<style lang="less" scoped>
.ux-ugc-wrap {
  .ugc-panel {
    padding-bottom: 20px;
    &.data-panel {
      margin-top: 0;
    }
    .ugc-panel-remark {
      font-size: 15px;
      white-space: nowrap;
      padding-top: 10px;
      font-weight: bold;
    }
    .ux-filter-title {
      display: inline-block;
      text-align: right;
      width: 64px;
      margin: 0 12px;
      font-weight: bold;
    }
    .data-panel-content {
      padding-top: 12px;
    }
  }
  
  .filter-wrap {
    display: flex;
    flex-wrap: wrap;
    
  }
  .filter {
    padding-bottom: 12px;
  }
}

span.sorter-icon {
  display: inline-block;
  width: 12px;
  .ant-icon {
    font-size: 12px;
  }
}
</style>


<style lang="less">
.ugc-gameplay-table {
  
  .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th,
  .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,
  .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
    padding: 5px 0;
  }
  .ant-table-thead > tr > th .ant-table-column-sorters .ant-table-column-sorter {
    margin: 0;
  }
  .trend_detail_box {
    background: #fff;
    padding: 30px 50px;
    h3 {
      text-align: left;
      border-left:3px solid #000;
      padding: 0 0 0 30px;
      line-height: 20px;
      &.inner_h3, &.inner_issue_h3{
        border-color: #ffcc81
      }
      &.lab_h3, &.lab_issue_h3{
        border-color: #d2e6bc;
      }
      &.feedback_h3{
        border-color: #1890ff;
      }
    }
    .ugc-gameplay-table-children {
      
      .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th, .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
        padding: 5px;
      }
    }
  }
}
.ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row), .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row), .ant-table-thead > tr:hover:not(.ant-table-expanded-row), .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) {
  background: #e6f7ff;
}

.obstacle-span {
    display: inline-block;
    width: 24px;
    line-height: 24px;
    border-radius: 50%;
    background-color: #c4c4c4;
    &.lv-1 {
      background-color: #f14949;
    }
    &.lv-2 {
      background-color: #ffc60a;
    }
    &.lv-3 {
      background-color: #fdddcd;
    }
    &.lv-4 {
      background-color: #c4c4c4;
    }
  }


.custom-ugc-gameplay-table {
  z-index: 999999;
  width: 100%;
  &:nth-child(2) {
    margin: -1px 0 0 0;
    z-index: 999998;
  }
  tr.custom-ugc-gameplay-table-tr {
    th, td {
      text-align: center;
      border: 1px solid #ddd;
      vertical-align: middle;
    }
    th {
      height: 40px;
      vertical-align: middle;
      background: #fafafa;
      font-size: 15px;
      &.sortable {
        cursor: pointer;
      }
      &.inner {
        background:#ffcc81;
      }
      &.outer {
        background: #d2e6bc;
      }
      div {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        .question {
          color: #666;
        }
      }
      span.filter-icon {
        position: absolute;
        right: 0px;
        padding: 0 5px;
        display: flex;
        align-items: center;

        height: 100%;
        cursor: pointer;
        .anticon {
          font-size: 12px;
          color: #aaa;
        }
        &:hover {
          background: #ddd;
        }
        &.active {
          .anticon {
            color: #1890ff;
          }
        }
      }
      span.sorter-icon {
        display: inline-block;
        width: 12px;
        height: 16px;
        position: relative;
        margin: 0 0 0 5px;
        cursor: pointer;
        &.sorter-asc {
          .anticon:nth-child(1) {
            color: #1890ff;
          }
        }
        &.sorter-desc {
          .anticon:nth-child(2) {
            color: #1890ff;
          }
        }
        .anticon {
          position: absolute;
          top: 0;
          left: 0;
          font-size: 10px;
          color: #6b6b6b;
          &:nth-child(2) {
            top: 7px;
          }
        }
      }
    }
    td {
      height: 80px;
      > div {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .link {
        cursor: pointer;
        text-decoration: underline;
        color: #1890ff;
      }
      .clickable {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
  
  .detail_box {
    position: relative;
    background: #fff;
    padding: 30px 60px;
    .detail_box_expand_btn {
      position: absolute;
      left: 0;
      color: #535353;
      border: 1px solid #ddd;
      background: #ededed;
      font-size: 12px;
      padding: 0 5px;
      cursor: pointer;
      span.anticon {
        font-size: 10px;
      }
    }
    h3 {
      text-align: left;
      border-left:3px solid #000;
      padding: 0 0 0 20px;
      line-height: 20px;
      margin: 0 0 20px 0;
      &.inner_h3{
        border-color: #ffcc81
      }
      &.lab_h3{
        border-color: #d2e6bc;
      }
      &.feedback_h3{
        border-color: #1890ff;
      }
    }
    .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th,
    .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-body > table > .ant-table-tbody > tr > td {
      padding: 5px;
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th, .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
      padding: 5px;
    }
  }
}


.ugc-table-filter-container {
  .ant-popover-inner-content {
    padding: 0;
  }
  .ugc-table-filter-box {
    height: 300px;
    overflow-y: auto;
    padding: 10px 16px;
    &::-webkit-scrollbar {
      width: 5px; /*滚动条宽度*/
      height: 5px; /*滚动条高度*/
      background: #f1f1f1;
    }

    /*定义滑块 内阴影+圆角*/
    &::-webkit-scrollbar-thumb {
      border-radius: 3px; /*滚动条的圆角*/
      background-color: #bbb; /*滚动条的背景颜色*/
    }
  }
}

.ugc-data-panel-stat-box {
  display: flex;
  .ugc-data-panel-stat {
    background: #d6d6d6;
    margin: 0 10px 0 0;
    h3 {
      font-size: 16px;
      text-align:center;
      padding: 5px 0;
      margin: 0;
      font-weight: bold;
        line-height: 24px;
    }
    .ugc-data-panel-stat-inner {
      display: flex;
      height: 50px;
      background:#efefef;
      
    }
    .ugc-data-panel-stat-item {
      width: 130px;
      border:3px solid #fff0;
      &-filter {
        cursor:pointer;
        user-select: none;
        label {
          cursor:pointer;
        }
      }
      &-selected {
        border-radius: 4px;
        box-sizing: border-box;
        border:3px solid #80d624;
      }
      label, span {
        display: block;
        text-align: center;
        font-size: 13px;
        font-weight: normal;
        line-height: 22px;
      }
      span {
        font-size: 15px;
        font-weight: bold;
      }
      &.ugc-data-panel-stat-single-item span{
        // line-height: 48px;
        // font-size: 20px;
      }
    }
    &.lab {
      background: #d2e6bc;
      .ugc-data-panel-stat-inner {
        background:#e3f2d2;
      }
    }
    &.inner {
      background: #ffcc81;
      .ugc-data-panel-stat-inner {
        background: rgba(255, 248, 237, 0.5);
      }

    }
  }
  .ugc-data-panel-stat.lab {
    position: relative;
    z-index: 1;
    .ugc-data-panel-stat-clear {
      transition: all 0.3s ease;
      z-index: -1;
      position: absolute;
      right: -24px;
      bottom: 0;
      font-size: 24px;
      background-color: #e3f2d2;
      border: 1px solid #e3f2d2;
      border-radius: 0 5px 5px 0;
      padding: 0 3px;
      cursor: pointer;
      &:hover {
        background-color: #d2e6bc;
        color:red;
      }
      &-hidden {
        right: 0;
      }
    }
  }
}

.ux-exp-tabs {
  padding-top: 20px;
  &.ant-tabs-card {
    .ant-tabs-content {
      margin-top: -16px;
      // .ant-tabs-tabpane {
      //   background: #fff;
      // }
    }
    .ant-tabs-bar {
      border-color: #fff;
      .ant-tabs-tab {
        border-color: transparent;
        background: transparent;
        font-size: 16px;
        font-weight: bold;
      }
      .ant-tabs-tab-active {
        border-color: #fff;
        background: #fff;
      }
    }
  }
}
</style>